import styled from "styled-components";

export const Container = styled.button`
    background-color: none;
    color: ${props => props.theme.colors.primaryText};
    border: none;
    display: flex;
    height: 100%;
    align-items: center;
    padding: 0 15px;
    font-size: 18px;
    font-weight: 500;
    cursor: pointer;
`;